export default {
  title: 'Cercas Eletrônicas',
  create_on_map: 'Criar no mapa →',
  updated: 'Cerca atualizada.',
  empty: 'Nenhuma cerca criada.',
  empty_hint: 'Use o painel "Criar Cerca Eletrônica" na tela do Mapa.',
  load_failed: 'Não foi possível carregar as cercas.',
  circle_radius: 'Círculo · raio {m} m',
  private: 'Zona de privacidade',
  notify_enter: 'entrada',
  notify_exit: 'saída',
  notify_on: 'Alerta na {what}',
  notify_none: 'Sem alertas',
  no_links: 'Sem vínculos — não monitora nada',
  monitors: 'Monitora {what}',
  tag_count: '{count} dispositivo | {count} dispositivos',
  group_count: '{count} grupo | {count} grupos',
  assign: 'Atribuir',
  assign_aria: 'Atribuir dispositivos e grupos à cerca {name}',
  edit_aria: 'Editar cerca {name}',
  monitor: 'Monitorar',
  tags_label: 'Dispositivos',
}
